import React from 'react';
import Hero from './Hero';
import About from './About';
import Trust from './Trust';
import Potential from './Potential';
import FAQ from './FAQ';

function HomePage() {
    return ( 
        <>
           
           <Hero />
           <About />
           <Trust />
           <Potential />
           <FAQ />
           
           
        </>
     );
}

export default HomePage;